/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliMedicalRecordDto } from '../../models/amoxcalli-medical-record-dto';

export interface ApiMedicalRecordsForParentGet$Json$Params {
  studentId?: string;
}

export function apiMedicalRecordsForParentGet$Json(http: HttpClient, rootUrl: string, params?: ApiMedicalRecordsForParentGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliMedicalRecordDto>> {
  const rb = new RequestBuilder(rootUrl, apiMedicalRecordsForParentGet$Json.PATH, 'get');
  if (params) {
    rb.query('studentId', params.studentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliMedicalRecordDto>;
    })
  );
}

apiMedicalRecordsForParentGet$Json.PATH = '/api/medical-records/for-parent';
